import ProductSection from "../../../../components/productSection/productSection";

export default function TopSellingSection(){
    return (
    <div style={{marginTop : "40px"}}>
        <div style={{display : "flex" , justifyContent : "center" , marginBottom : "20px"}}>
        <hr style={{width : "50%" , color : "#F0EEED"}}></hr>
        </div>
     <ProductSection endPoint = "topSelling-products" title = "TOP SELLING" link = "/view-all-topSelling"/>
    </div>
    )
}